import MarketingNav from "@/components/marketing/MarketingNav";
import MarketingFooter from "@/components/marketing/MarketingFooter";
import {
  Brain, CheckCircle2, Send, BarChart3, Bell, Shield,
  Zap
} from "lucide-react";

const FEATURES = [
  {
    icon: Brain,
    title: "Smart Task Creation",
    desc: "Automatically converts WhatsApp messages into actionable tasks with intelligent categorization"
  },
  {
    icon: Send,
    title: "AI Reply Suggestions",
    desc: "Draft professional replies instantly using GPT-powered suggestions"
  },
  {
    icon: CheckCircle2,
    title: "Auto Follow-ups",
    desc: "Never miss a follow-up again with smart reminders based on message context"
  },
  {
    icon: Zap,
    title: "WhatsApp Integration",
    desc: "Seamlessly connects with your WhatsApp Business without complex setup"
  },
  {
    icon: BarChart3,
    title: "Dashboard & Tracking",
    desc: "Unified view of all conversations, tasks, and action items in one place"
  },
  {
    icon: Bell,
    title: "Smart Notifications",
    desc: "Get real-time alerts for urgent items and pending actions you need to take"
  },
  {
    icon: Shield,
    title: "Message Classification",
    desc: "Categorizes messages as Follow-ups, Enquiries, Support, or Opportunities"
  },
];

export default function FeaturesPage() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="features-page">
      <MarketingNav />

      {/* Hero */}
      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-heading text-5xl sm:text-6xl font-bold text-slate-900 mb-6">
            Powerful features for WhatsApp productivity
          </h1>
          <p className="text-xl text-slate-600">
            Everything you need to turn WhatsApp into your task management engine
          </p>
        </div>
      </section>

      {/* Features Grid */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {FEATURES.map((feature, i) => (
              <div key={i} className="bg-white border border-slate-200 rounded-2xl p-8 hover:shadow-lg transition">
                <feature.icon className="w-12 h-12 text-blue-600 mb-4" />
                <h3 className="font-heading text-xl font-bold text-slate-900 mb-3">{feature.title}</h3>
                <p className="text-slate-600 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}
